type ThankYouData = {
  imageSrc: string;
  title: string;
  description: string;
};

const ThankYou = () => {
  const data: ThankYouData = {
    imageSrc: "/general/thank_you.webp",
    title: "We are Here For You - Just sit back and relax",
    description: "While you wait, one of our agents will get back to you shortly.",
  };

  return (
    <>
      <section className="pb-20 md:pt-14">
        <div className="container mx-auto px-4 md:mt-20">
          <div className="flex flex-wrap justify-between items-center gap-8">
            <div className="w-full lg:w-1/4 p-4 md:p-0 md:ml-28">
              <img src={data.imageSrc} alt="Thank you image" className="w-full" />
            </div>
            <div className="w-full lg:w-2/4">
              <div className="text-center lg:text-left">
                <div className="text-6xl font-bold mb-5">
                  THANK<span className="text-halo-pink"> YOU</span>
                </div>
                <h2 className="text-2xl font-semibold">
                  We are <span className="text-halo-pink">Here For You</span> - Just sit back and relax
                </h2>
                <p className="text-gray-700 lg:pr-8">{data.description}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;